import {Component, OnDestroy, OnInit} from '@angular/core';
import {FieldType, FormlyModule} from '@ngx-formly/core';
import {CommonModule} from '@angular/common';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzDatePickerModule} from 'ng-zorro-antd/date-picker';
import {DatePickerComponent} from '../components/date-picker';

@Component({
  selector: 'zorrly-date-range',
  standalone: true,
  imports: [
    CommonModule,
    FormlyModule,
    NzSelectModule,
    ReactiveFormsModule,
    DatePickerComponent,
    NzFormModule,
    FormsModule,
    NzDatePickerModule,
  ],
  template: `
    <nz-range-picker [(ngModel)]="range" [nzShowTime]="props.showTime"
                     (ngModelChange)="onChange($event)"></nz-range-picker>
  `,
})
export class ZorrlyDateRangeComponent extends FieldType implements OnInit, OnDestroy {

  range: any;

  ngOnInit(): void {
    const {start, end} = this.formControl.value;
    this.range = [start, end];
  }

  ngOnDestroy(): void {
  }

  onChange(data: any) {
    this.formControl.patchValue({start: this.range[0], end: this.range[1]});
  }
}
